// WalletContext.js
import React, { createContext, useState, useEffect } from "react";
import { ethers, verifyMessage } from "ethers";
import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = `${process.env.REACT_APP_API_URL}/wallet`;
export const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const [walletAddress, setWalletAddress] = useState(
    localStorage.getItem("walletAddress") ?? null
  );

  useEffect(() => {
    const storedWallet = localStorage.getItem("walletAddress");
    if (storedWallet) {
      setWalletAddress(storedWallet);
    }
  }, []);

  // Inside WalletContext.js
  const connectWallet = async () => {
    toast.dismiss();
    if (!window.ethereum) {
      toast.error("Please install MetaMask");
      return;
    }

    try {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const wallet = accounts[0];
      const message = "Sign this message to authenticate with the app.";

      const signature = await window.ethereum.request({
        method: "personal_sign",
        params: [message, wallet],
      });

      const recoveredAddress = verifyMessage(message, signature);

      const response = await axios.post(baseUrl, {
        walletAddress: wallet,
        signatureMessage: signature,
      });

      if (response.data && response.data.wallet) {
        setWalletAddress(wallet);
        localStorage.setItem("walletAddress", wallet);
      } else {
        setWalletAddress(null);
        toast.error("Failed to save wallet. You have been disconnected.");
      }
    } catch (error) {
      console.error("Error connecting wallet:", error);
      setWalletAddress(null);
      toast.error("Failed to connect wallet.");
    }
  };

  const disconnectWallet = () => {
    localStorage.removeItem("walletAddress");
    setWalletAddress(null);
  };

  return (
    <WalletContext.Provider
      value={{ walletAddress, connectWallet, disconnectWallet }}
    >
      {children}
    </WalletContext.Provider>
  );
};
